import { TextField, TextFieldProps } from "@mui/material";

type AppTextInputProps = TextFieldProps;

const AppTextInput = (props: AppTextInputProps) => {
  return <TextField fullWidth margin="dense" variant="outlined" {...props} />;
};

export default AppTextInput;
